var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelectAuction,
            width: "720px",
            "append-to-body": "",
            title: "选择直播间",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelectAuction = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c(
                "el-radio-group",
                {
                  staticClass: "mr20",
                  staticStyle: { display: "block" },
                  attrs: { type: "button", size: "small" },
                  on: { change: _vm.searchAAction },
                  model: {
                    value: _vm.live_status,
                    callback: function ($$v) {
                      _vm.live_status = $$v
                    },
                    expression: "live_status",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "" } }, [
                    _vm._v("全部"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: 1 } }, [
                    _vm._v("预告中"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: 2 } }, [
                    _vm._v("直播中"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: 3 } }, [
                    _vm._v("已结束"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: -1 } }, [
                    _vm._v("已取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "h400 mt20",
              staticStyle: { "border-top": "1px solid #eee" },
            },
            [
              _c(
                "table",
                { staticClass: "spec-table mt20" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticStyle: { height: "30px" },
                          attrs: { width: "40%", align: "left" },
                        },
                        [_vm._v("直播信息")]
                      ),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "30%", align: "left" } }, [
                        _vm._v("直播时间"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "15%", align: "center" } }, [
                        _vm._v("直播状态"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "15%", align: "center" } }, [
                        _vm._v("操作"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.resultData, function (m, i) {
                    return _c("tbody", { key: i, staticClass: "list" }, [
                      _c("tr", { staticClass: "border-t" }, [
                        _c("td", { staticClass: "bgWhite" }, [
                          _c(
                            "div",
                            { staticClass: "display-flex item-align-center" },
                            [
                              m.cover_image
                                ? _c("img", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                      display: "block",
                                      "flex-shrink": "0",
                                    },
                                    attrs: { src: m.cover_image + "!120a" },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "ml10 flex-one textAlignL" },
                                [
                                  _c("p", [
                                    _vm._v("直播标识：" + _vm._s(m.live_id)),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "mt5" }, [
                                    _vm._v(_vm._s(m.live_title)),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "开播：" +
                                  _vm._s(
                                    _vm.parseTime(
                                      m.start_time,
                                      "{y}-{m}-{d} {h}:{i}"
                                    )
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  m.end_time
                                    ? "结束：" +
                                        _vm.parseTime(
                                          m.end_time,
                                          "{y}-{m}-{d} {h}:{i}"
                                        )
                                    : ""
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            m.live_status == 1
                              ? _c("div", [_vm._v("待开播")])
                              : m.live_status == 2
                              ? _c("div", [_vm._v("直播中")])
                              : m.live_status == 3
                              ? _c("div", [_vm._v("已结束")])
                              : m.live_status == -1
                              ? _c("div", [_vm._v("已取消")])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            _vm.selectedAuctionIdList.indexOf(m.live_id) == -1
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.auctionSelectedAction(
                                            $event,
                                            i
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("选择")]
                                  ),
                                ])
                              : _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          _vm.auctionCancelAction(
                                            $event,
                                            _vm.selectedAuctionIdList.indexOf(
                                              m.live_id
                                            )
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("取消选择")]
                                  ),
                                ]),
                          ]
                        ),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-e mt20" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.queryParams.limit,
                  "current-page": _vm.queryParams.page,
                  layout: "total, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: { "current-change": _vm.pageChange },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "item-flex-center",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "mr20",
                  attrs: { type: "primary" },
                  on: { click: _vm.cursorSelect },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showSelectAuction = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }